module.exports = __webpack_public_path__ + "img/float_role.c83a27e.png";